var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"fade-kit"}},[(_vm.isLoading)?_c('div',{class:_vm.$style.container},[_c('content-loader',{attrs:{"is-loading":_vm.isLoading,"size":_vm.size,"delay":_vm.delay}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }